import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeading } from './ui/SectionHeading';
import { Check } from 'lucide-react';
export function About() {
  return <section id="nosotros" className="py-24 md:py-32 bg-surface" data-id="element-14">
      <div className="container mx-auto px-6 md:px-12" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-16">
          {/* Image Grid */}
          <div className="relative" data-id="element-17">
            <FadeIn direction="right" data-id="element-18">
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-lg aspect-[4/5] w-[85%]" data-id="element-19">
                <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=1000" alt="Interior de clínica premium" className="w-full h-full object-cover" data-id="element-20" />
              </div>
            </FadeIn>

            <FadeIn direction="up" delay={0.2} className="absolute bottom-10 right-0 w-[55%] z-20" data-id="element-21">
              <div className="rounded-2xl overflow-hidden shadow-xl border-4 border-surface aspect-square" data-id="element-22">
                <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&q=80&w=800" alt="Doctora especialista" className="w-full h-full object-cover" data-id="element-23" />
              </div>

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -left-6 bg-gold text-gold-foreground p-6 rounded-xl shadow-gold backdrop-blur-sm" data-id="element-24">
                <div className="font-serif text-4xl mb-1" data-id="element-25">20+</div>
                <div className="text-xs uppercase tracking-widest font-medium" data-id="element-26">
                  Años de
                  <br data-id="element-27" />
                  Experiencia
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Content */}
          <div data-id="element-28">
            <SectionHeading title="Más de 20 años ayudando a nuestros pacientes" alignment="left" className="mb-8" data-id="element-29" />

            <FadeIn delay={0.2} data-id="element-30">
              <p className="text-lg text-muted-foreground font-light leading-relaxed mb-8" data-id="element-31">
                En Libelle Estética, creemos que la verdadera belleza reside en
                la armonía y la naturalidad. Nuestro enfoque médico integral nos
                permite diseñar planes de tratamiento personalizados que
                respetan tu esencia mientras realzan tu mejor versión.
              </p>
              <p className="text-lg text-muted-foreground font-light leading-relaxed mb-10" data-id="element-32">
                Liderados por un equipo de especialistas apasionados por la
                excelencia, combinamos la ciencia médica más avanzada con un
                profundo sentido estético.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-33">
              <ul className="space-y-4 mb-10" data-id="element-34">
                {['Evaluación médica exhaustiva', 'Protocolos basados en evidencia científica', 'Acompañamiento continuo durante tu tratamiento'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-35">
                    <div className="w-6 h-6 rounded-full bg-champagne flex items-center justify-center flex-shrink-0" data-id="element-36">
                      <Check className="w-3.5 h-3.5 text-gold" data-id="element-37" />
                    </div>
                    <span className="text-foreground font-medium" data-id="element-38">{item}</span>
                  </li>)}
              </ul>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-39">
              <div className="pt-8 border-t border-border" data-id="element-40">
                <p className="font-serif text-2xl italic text-foreground" data-id="element-41">
                  "Nuestra misión es que te sientas seguro y radiante en tu
                  propia piel."
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}